import type { ShareLinkData, ShareLinkResponse } from '../types';

export const ShareIdApi = Symbol('ShareIdApi');

export interface ShareIdApi {
    getShareIdForGuest(inputData: ShareLinkData): Promise<ShareLinkResponse>
    getShareId(inputData: ShareLinkData): Promise<ShareLinkResponse>
    getPDAShareId(data: {file_group_id: string}): Promise<{share_id: string}>
    sendPDAShareByEmail(data: {share_id: string, receptor: string[]}): Promise<boolean>
}
